<div class="compliance-fallback-container">
  <!-- Main insights card -->
  <mat-card class="fallback-card" [ngClass]="'severity-' + errorCategory.severity">
    <mat-card-header>
      <div mat-card-avatar class="fallback-avatar" [ngClass]="'severity-' + errorCategory.severity">
        <mat-icon>{{ getIconForSeverity(errorCategory.severity) }}</mat-icon>
      </div>
      <mat-card-title>{{ getTitle() }}</mat-card-title>
      <mat-card-subtitle>{{ getSubtitle() }}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="fallback-content">
        <!-- Analysis not available - new insights workflow -->
        @if (errorCategory.type === 'ANALYSIS_NOT_AVAILABLE') {
          <div class="insights-workflow">
            <p><strong>Generate insights for this page:</strong></p>
            <mat-form-field appearance="outline" class="insight-select">
              <mat-label>Select analysis type</mat-label>
              <mat-select [(value)]="selectedInsightType">
                @for (option of insightOptions; track option) {
                  <mat-option [value]="option.value" [disabled]="option.disabled">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="start-button-container">
              <button mat-raised-button color="primary" [disabled]="!selectedInsightType" (click)="onStartInsights()">
                <mat-icon>play_arrow</mat-icon>
                Start
              </button>
            </div>
          </div>
        }

        <!-- Other error types - simplified messaging -->
        @if (errorCategory.type !== 'ANALYSIS_NOT_AVAILABLE') {
          <div class="other-error-info">
            <p>{{ getErrorMessage() }}</p>
          </div>
        }

        <!-- Technical details (collapsible) -->
        @if (showTechnicalDetails) {
          <details class="technical-details">
            <summary>Technical Details</summary>
            <div class="technical-content">
              <strong>Error Type:</strong>
              {{ errorCategory.type }}
              <br />
              <strong>Message:</strong>
              {{ errorCategory.technicalMessage }}
            </div>
          </details>
        }
      </div>
    </mat-card-content>

    <mat-card-actions>
      @if (errorCategory.canRetry) {
        <button mat-button (click)="onRetry()" color="primary">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      }

      @if (errorCategory.type !== 'ANALYSIS_NOT_AVAILABLE') {
        <button mat-button (click)="onContactSupport()">
          <mat-icon>support</mat-icon>
          Contact Support
        </button>
      }

      <button mat-button (click)="toggleTechnicalDetails()">
        <mat-icon>{{ showTechnicalDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ showTechnicalDetails ? 'Hide' : 'Show' }} Details
      </button>
    </mat-card-actions>
  </mat-card>
</div>
